<template>
  <div>
    <ControlPanel :title="'Главная страница'" :icon="'mdi mdi-home'" :links="links">
    </ControlPanel>
    <div class="container-fluid">
      <Category>
        <template v-slot:pos0>
          <h1 class="text-center">Сервис расчета заработной платы в Казахстане</h1>
        </template>
        <template v-slot:pos1>
          <p>С помощью данного сайта вы можете рассчитать заработную плату по правилам действующего законодательства Республики Казахстан.</p>
          <p>Сервис предоставляет расширенный список услуг по расчету зарплаты, ведению накопительной базы по заработной плате сотрудников, формированию документации и отчетов, в том числе и для сдачи в налоговые органы.</p>
          <p>Вы можете перейти в любой раздел сайта, воспользовавшись меню сверху или списком в разделе "Функционал" справа или сразу перейти в калькулятор, нажав кнопку ниже.</p>
          <p class="text-center"><b-link class="btn btn-s btn-danger" to="/salary/calculator/"><span class="mdi mdi-calculator"></span> ПЕРЕЙТИ В КАЛЬКУЛЯТОР ЗАРПЛАТЫ</b-link></p>

          <hr>

          <b-nav fill>
            <b-nav-item><b-link to="/info/description/">О сервисе</b-link></b-nav-item>
            <b-nav-item><b-link to="/info/price/">Ознакомиться с расценками</b-link></b-nav-item>
            <b-nav-item><b-link to="/info/reviews/">Отзывы наших клиентов</b-link></b-nav-item>
          </b-nav>
        </template>

        <template v-slot:pos2-title>Список всего функционала</template>
        <template v-slot:pos2>
          <h3></h3>
          <table class="table table-sm table-bordered">
            <tr class="bg-light">
              <th class="text-center"><b-link to="/salary/">Зарплата</b-link></th>
            </tr>
            <tr>
              <td><b-link to="/salary/calculator/">Калькулятор заработной платы</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/salary/sums/">Сохраненные начисления заработной платы</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/salary/additionalcharges/">Калькулятор отпускных, больничных листов, компенсации отпуска при увольнении</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/salary/additionalcalcs/">Сохраненные расчеты отпускных, больничных листов, компенсации отпуска при увольнении</b-link></td>
            </tr>

            <tr class="bg-light">
              <th class="text-center"><b-link to="/registers/">Справочники</b-link></th>
            </tr>
            <tr>
              <td><b-link to="/registers/organizations/">Справочник организаций</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/registers/workers/">Справочник сотрудников</b-link></td>
            </tr>

            <tr class="bg-light">
              <th class="text-center"><b-link to="/docs/">Документы</b-link></th>
            </tr>
            <tr>
              <td><b-link to="/docs/salarycertificate/">Справка о заработной плате</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/docs/payslip/">Расчётный листок сотрудника</b-link></td>
            </tr>

            <tr class="bg-light">
              <th class="text-center"><b-link to="/bank/">Банк</b-link></th>
            </tr>
            <tr>
              <td><b-link to="/bank/swift/">Формирование файлов SWIFT</b-link></td>
            </tr>


            <tr class="bg-light">
              <th class="text-center"><b-link to="/reports/">Отчёты</b-link></th>
            </tr>
            <tr>
              <td><b-link to="/reports/200.00/">Регламентированный отчёт: форма 200.00</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/reports/910.00/">Регламентированный отчёт: форма 910.00</b-link></td>
            </tr>


          </table>
        </template>
      </Category>
    </div>
  </div>
</template>

<script>
import ControlPanel from "@/components/base/ControlPanel";
import Category from "@/components/base/Category";
import {mapGetters} from "vuex";

export default {
  name: 'MainDefault.vue',
  components: {
    ControlPanel,
    Category
  },
  data: function () {
    return {

    }
  },
  computed:  {
    ...mapGetters({
      links: 'links'
    })
  },
}
</script>

<style scoped>

</style>